module.exports = __webpack_public_path__ + "static/media/ficus-tree-only-small.8621472f.png";